export const fromLocalStorage = (key: string, variables?: any) => {
  const org = variables?.organizationId || 'default';
  return window.localStorage.getItem(`${org}:${key}`);
};
